import {Component} from 'react'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import {FaStar, FaExternalLinkAlt} from 'react-icons/fa'
import {MdLocationOn} from 'react-icons/md'
import {BsFillBriefcaseFill} from 'react-icons/bs'
import Header from '../Header/index'
import SimilarJobs from '../SimilarJobs/index'
import './index.css'

const apiStatus = {
  succ: 'SUCCESS',
  fail: 'FAILURE',
  load: 'LOADING',
}

class JobItemDetails extends Component {
  state = {status: apiStatus.load, obj: []}

  componentDidMount() {
    this.oper()
  }

  oper = async () => {
    const {match} = this.props
    const {params} = match
    const {id} = params
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const resp = await fetch(`https://apis.ccbp.in/jobs/${id}`, options)
    const res = await resp.json()
    if (resp.ok) {
      let job = res.job_details
      const formatJobDetails = {
        companyLogoUrl: job.company_logo_url,
        companyWebsiteUrl: job.company_website_url,
        employmentType: job.employment_type,
        id: job.id,
        jobDescription: job.job_description,
        lifeAtCompany: {
          description: job.life_at_company.description,
          imageUrl: job.life_at_company.image_url,
        },
        location: job.location,
        packagePerAnnum: job.package_per_annum,
        rating: job.rating,
        title: job.title,
        skills: job.skills.map(skill => ({
          name: skill.name,
          imageUrl: skill.image_url,
        })),
      }
      job = res.similar_jobs
      const formatSimilarJobs = job.map(j => ({
        companyLogoUrl: j.company_logo_url,
        employmentType: j.employment_type,
        id: j.id,
        jobDescription: j.job_description,
        location: j.location,
        rating: j.rating,
        title: j.title,
      }))
      const upd = [formatJobDetails, formatSimilarJobs]

      this.setState({status: apiStatus.succ, obj: upd})
    } else {
      this.setState({status: apiStatus.fail})
    }
  }

  renderSucc = () => {
    const {obj} = this.state
    const {
      companyLogoUrl,
      companyWebsiteUrl,
      employmentType,
      jobDescription,
      lifeAtCompany,
      location,
      packagePerAnnum,
      rating,
      title,
      skills,
    } = obj[0]

    return (
      <div className="mdm">
        <div className="jobD">
          <div>
            <div className="logodiv">
              <img
                alt="job details company logo"
                className="logo"
                src={companyLogoUrl}
              />
              <div>
                <h1>{title}</h1>
                <div className="starrow">
                  <FaStar className="star" />
                  <p>{rating}</p>
                </div>
              </div>
            </div>
            <div className="locodiv">
              <div className="row">
                <div className="row">
                  <MdLocationOn className="m" />
                  <p>{location}</p>
                </div>
                <div className="row">
                  <BsFillBriefcaseFill className="m" />
                  <p>{employmentType}</p>
                </div>
              </div>
              <div>
                <p>{packagePerAnnum}</p>
              </div>
            </div>
            <hr className="line" />
            <div>
              <div className="locodiv">
                <h1>Description</h1>
                <a href={companyWebsiteUrl}>
                  <p>Visit</p>
                  <FaExternalLinkAlt />
                </a>
              </div>
              <p>{jobDescription}</p>
              <h1>Skills</h1>
              <div>
                <ul className="skills-list">
                  {skills.map(e => (
                    <li key={e.name}>
                      <img alt={`${e.name}`} src={e.imageUrl} />
                      <p>{e.name}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h1>Life at Company</h1>
                <div className="row">
                  <p>{lifeAtCompany.description}</p>
                  <img alt="life at company" src={lifeAtCompany.imageUrl} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h1>Similar Jobs</h1>
          <ul className="listt">
            {obj[1].map(e => (
              <SimilarJobs key={e.id} lis={e} />
            ))}
          </ul>
        </div>
      </div>
    )
  }

  renderLoad = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderFail = () => (
    <div className="loader-container">
      <img
        alt="failure view"
        src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
      />
      <h1>Oops! Something Went Wrong</h1>
      <p>We cannot seem to find the page you are looking for.</p>
      <button onClick={this.oper} type="button">
        Retry
      </button>
    </div>
  )

  check = () => {
    const {status} = this.state
    switch (status) {
      case apiStatus.succ:
        return this.renderSucc()
      case apiStatus.fail:
        return this.renderFail()
      case apiStatus.load:
        return this.renderLoad()
      default:
        return null
    }
  }

  render() {
    return (
      <div>
        <Header />
        <div className="itemmdiv">{this.check()}</div>
      </div>
    )
  }
}

export default JobItemDetails
